
import { Component, Prop,Mixins} from 'vue-property-decorator'
import Common from '@/mixins/common'
import {Playground } from '@/common-datatypes'
import StaffInboxOnReferenceObjects from "@/components/StaffInboxOnReferenceObjects.vue";
import ModalPlaygroundMessenger from "@/components/ModalStaffPlaygroundMessenger.vue"


@Component({
  components: {
    StaffInboxOnReferenceObjects,
    ModalPlaygroundMessenger
  }
})

export default class ModalStaffPlaygroundMessageList extends Mixins(Common) {
  @Prop({type: String, default: ''}) private message?: string
  @Prop({type: String, default: 'message.yes'}) private confirmText?: string
  @Prop({type: String, default: 'message.no'}) private cancelText?: string
  @Prop({type: String, default: ''}) private errorMessage?: string
  @Prop({type: Object, default: {}}) private thePlayground?: Playground

  isLoading: boolean | string = false

  isActive = true

  defaultModalMessengerProps = {
    replyMessageId: '',
    replyAllMessageId: '',
    reviewMessageId: '',
    theMessageId: '',
    thePlayground: this.thePlayground,
    isShow: false
  }

  modalMessengerProps = {} as this["defaultModalMessengerProps"]


  createMessage(){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      thePlayground: this.thePlayground,
      isShow: true
    }
  }

  get referenceObjectIds(){
    return (this.thePlayground?.docId) ? [this.thePlayground?.docId] : []
  }

  get playgroundId(){
    return this.thePlayground?.docId || ''
  }

  get title(){
    return this.thePlayground?.title || ''
  }

  async created(){
    //
  }

  mounted(){
    //
  }
/*
  selectAction(type: string){
    this.$emit("selectAction",{
      type: type,
      eventId: this.eventId
    })
  }
*/
  onConfirm(yes: boolean) {
    this.$emit("onConfirm", yes)
  }

  editMessage(messageId: string){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      theMessageId: messageId,
      thePlayground: this.thePlayground,
      isShow: true
    }
  }

  replyMessage(messageId: string){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      replyMessageId: messageId,
      thePlayground: this.thePlayground,
      isShow: true
    }
  }

  replyAllMessage(messageId: string){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      replyAllMessageId: messageId,
      thePlayground: this.thePlayground,
      isShow: true
    }
  }

  reviewMessage(messageId: string){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      reviewMessageId: messageId,
      thePlayground: this.thePlayground,
      isShow: true
    }
  }

  destroyed() {
    console.trace('destroyed');
  }
}
